import { doubleEncode, makePutRequest } from "../../utils";

type UpdateSessionStatusOptions = {
	sessionId: string;
};
export const updateSessionStatus = async (
	token: string,
	options: UpdateSessionStatusOptions,
) => {
	await makePutRequest({
		token,
		pathList: [
			"v2",
			"videosdk",
			"sessions",
			doubleEncode(options.sessionId),
			"status",
		],
		options: {},
		body: {
			action: "end",
		},
	});
	return 204;
};
export const curriedUpdateSessionStatus = (token: string) => (
	options: UpdateSessionStatusOptions,
) => updateSessionStatus(token, options);
